import { ProfileIcon, SecurityIcon } from "@simulanisindia/ui";
import { RoleInformationIcon } from "../assets/Icons";

export const roleInfoTab = [
  {
    id: 1,
    title: "Role Information",
    icon: <ProfileIcon />,
    hasDropdown: true,
    id_link: "#roleinfo",
    submenu: [],
  },
];

export const rolePermissionTab = [
  {
    id: 2,
    title: "Permissions",
    icon: <SecurityIcon />,
    hasDropdown: true,
    id_link: "#team-management",
    submenu: [
      { title: "Team Management", id_link: "#team-management", key:"TEAM.ALL" },
      { title: "Resource Management", id_link: "#resource-management", key: "RESOURCE.ALL" },
      { title: "Training", id_link: "#training", key: "TRAINING.ALL" },
      // { title: "Guiding", id_link: "#guiding", key: "GUIDING.ALL" },
      // { title: "Collaborating", id_link: "#collaborating", key: "COLLABORATION.ALL" },
      // { title: "Authoring", id_link: "#authoring", key: "AUTHORING.ALL" },
      // { title: "Content Management", id_link: "#content-management", key: "CONTENT.VIEW" },
      { title: "General Permissions", id_link: "#general-permissions", key: "GENERAL.ALL" },
      // { title: "Productivity", id_link: "#productivity", key: "PRODUCTIVITY.ALL" },
    ],
  },
];

export const roleAssignmentTab = [
  {
    id: 3,
    title: "Role Assignments",
    icon: <RoleInformationIcon />,
    hasDropdown: true,
    id_link: "#role-assignments",
    submenu: [],
  },
];

export const isMobile = (width, height) => {
  if (width < 1000 && height > width) {
    return true;
  }
  return false;
};
